var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: { id: "dashboard" },
    },
    [
      _c(
        "el-container",
        [
          _c("el-input", {
            staticStyle: { width: "400px" },
            attrs: { placeholder: "Search text" },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "Form Type" },
              model: {
                value: _vm.formType,
                callback: function ($$v) {
                  _vm.formType = $$v
                },
                expression: "formType",
              },
            },
            [
              _c("el-option", { attrs: { label: "All Forms", value: null } }),
              _vm._v(" "),
              _c("el-option", {
                attrs: { label: "Furniture+Lighting", value: "lighting" },
              }),
              _vm._v(" "),
              _c("el-option", {
                attrs: { label: "Future House", value: "house" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.loadData } },
            [_vm._v("Search")]
          ),
          _vm._v(" "),
          _vm.formType
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.downloadCSV } },
                [_vm._v("Download CSV")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            "default-sort": { prop: "id", order: "descending" },
            data: _vm.tableData,
            stripe: "",
          },
          on: { "sort-change": _vm.handleSortChange },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "70", sortable: "" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "form_type",
              label: "Type",
              width: "80",
              align: "center",
              sortable: "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "Created At", sortable: "" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "paid_at", label: "Paid At", sortable: "" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "pay_method",
              label: "Payment Method",
              sortable: "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "payment_reference",
              label: "Payment Ref.",
              sortable: "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var column = ref.column
                  var $index = ref.$index
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-edit", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleShowDetails(row)
                          },
                        },
                      },
                      [_vm._v("View")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 20, 30, 40],
          layout: "sizes, prev, pager, next, total",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
          "update:currentPage": function ($event) {
            _vm.currentPage = $event
          },
          "update:current-page": function ($event) {
            _vm.currentPage = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.modalTitle,
            visible: _vm.dialogVisible,
            width: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.rowToShow
            ? [
                _vm._l(_vm.rowToShow.content, function (section, idx) {
                  return [
                    _c(
                      "el-row",
                      {
                        key: "title" + idx,
                        staticClass: "detailrow",
                        attrs: { gutter: 10 },
                      },
                      [
                        _c("el-col", { attrs: { span: idx == 0 ? 8 : 24 } }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(section.title) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        idx == 0
                          ? _c(
                              "el-col",
                              { attrs: { span: "16", align: "right" } },
                              [
                                _c(
                                  "el-popconfirm",
                                  {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading.fullscreen.lock",
                                        value: _vm.fullScreenLoading,
                                        expression: "fullScreenLoading",
                                        modifiers: {
                                          fullscreen: true,
                                          lock: true,
                                        },
                                      },
                                    ],
                                    attrs: { title: "Are you sure?" },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.sendInvoice(true)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "reference",
                                          size: "medium",
                                        },
                                        slot: "reference",
                                      },
                                      [_vm._v("Send Pre-Invoice")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: { title: "Are you sure?" },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.sendInvoice()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "reference",
                                          size: "medium",
                                        },
                                        slot: "reference",
                                      },
                                      [_vm._v("Send Invoice")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.rowToShow.proforma
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { size: "medium" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getInvoice(
                                              _vm.rowToShow.id,
                                              "proforma"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Download Pre-Invoice")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  [
                                    _vm.rowToShow.invoice
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { size: "medium" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.getInvoice(
                                                  _vm.rowToShow.id,
                                                  "invoice"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Download Invoice")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    section.type == "cols"
                      ? _c(
                          "el-row",
                          {
                            key: "detailrow" + idx,
                            staticClass: "detailformfield",
                            attrs: { gutter: 10 },
                          },
                          [
                            _vm._l(section.fields, function (field, fieldId) {
                              return [
                                _c(
                                  "el-col",
                                  {
                                    key: "fieldname" + idx + fieldId,
                                    staticClass: "labelfield",
                                    attrs: {
                                      title: field.fieldname,
                                      span: "6",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(field.fieldname) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    key: "fieldvalue" + idx + fieldId,
                                    staticClass: "valuefield",
                                    attrs: { span: "6" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          field.value ? field.value : "-"
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            }),
                          ],
                          2
                        )
                      : _c("div", { key: "detailtext" + idx }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(section.value) +
                              "\n                "
                          ),
                        ]),
                  ]
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "detailrow", attrs: { gutter: 10 } },
            [
              _c("el-col", { attrs: { span: "24" } }, [
                _vm._v("\n                Files\n            "),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.rowToShow && _vm.rowToShow.files && _vm.rowToShow.files.length > 0
            ? _c(
                "el-row",
                { attrs: { gutter: 10 } },
                _vm._l(_vm.rowToShow.files, function (file, fileIdx) {
                  return _c(
                    "el-col",
                    { key: "file" + fileIdx, attrs: { span: "6" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-download" },
                          on: {
                            click: function ($event) {
                              return _vm.getFile(file)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "Download File " +
                              _vm._s(fileIdx + 1) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              )
            : _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c("el-col", { attrs: { span: "24" } }, [
                    _vm._v("\n                No files uploaded\n            "),
                  ]),
                ],
                1
              ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }